import {
  useIsOwnProfile,
  useProfile,
} from 'containers/profile/hooks/useProfile'
import { useContext, useState } from 'react'
import { AboutSection } from './AboutSection'
import { CollapsibleLayout } from '../../layouts/CollapsibleLayout'
import { ProfileTagsSection } from './ProfileTagsSection'
import { TextSkeleton } from '@/components/skeleton/TextSkeleton'
import { ProjectListSection } from '../../../projects/components/ProjectListSection'
import { HighlightsList } from 'containers/highlights/components/HighlightsList'
import { ProfileOverviewAnalyticsEmptyState } from 'containers/analytics/components/ProfileOverviewAnalyticsEmptyState'
import { ProfileViewNotification } from 'containers/profile-views/notification-card'
import { BrowserContext } from 'context'
import { useOauthStatus } from 'containers/oAuth/hooks/useSocialsConnection'
import { DealSyncCard } from 'containers/deal-sync/DealSyncCard'

export const PersonalInfoLoading = () => {
  return (
    <div
      className="full-w bg-white-primary px-20 py-16 rounded-b-12 rounded-t-12--tablet full-w"
      style={{
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <div className="flex flex-column gap-16">
        <TextSkeleton width={100} height={20} />
        <TextSkeleton height={20} />
        <TextSkeleton width={'55%'} height={20} />
        <div className="mt-12 flex flex-column gap-12 hidden flex--tablet">
          <TextSkeleton width={100} height={20} />
          <div className="flex gap-12 flex-wrap hidden flex--tablet">
            <TextSkeleton width={100} height={30} />
            <TextSkeleton width={150} height={30} />
            <TextSkeleton width={250} height={30} />
            <TextSkeleton width={90} height={30} />
            <TextSkeleton width={200} height={30} />
            <TextSkeleton width={200} height={30} />
          </div>
        </div>
        <div className="mt-12 flex flex-column gap-12 hidden flex--tablet">
          <TextSkeleton width={140} height={20} />
          <div className="flex gap-12 flex-wrap">
            <TextSkeleton width={100} height={30} />
            <TextSkeleton width={250} height={30} />
            <TextSkeleton width={200} height={30} />
          </div>
        </div>
      </div>
    </div>
  )
}

export const ProfileInfo = () => {
  const { profile, isLoading } = useProfile()
  const isOwnProfile = useIsOwnProfile()
  const [isCollapsed, setIsCollapsed] = useState(false)
  const { isMobile } = useContext(BrowserContext)
  const { noSocialConnected } = useOauthStatus(profile?.id)
  const showAnalyticsEmptyState = noSocialConnected && isOwnProfile

  if (isLoading) return <PersonalInfoLoading />

  return (
    <div className="flex flex-column gap-32 ">
      {isOwnProfile && !isMobile && (
        <div className="px-20 px-0--desktop">
          <ProfileViewNotification />
        </div>
      )}

      <div
        className="bg-white-primary px-20 py-16 rounded-b-12 rounded-t-12--tablet full-w"
        style={{
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <div className="flex flex-column gap-16">
          <AboutSection trimmed={!isCollapsed} />
          <CollapsibleLayout onOpenChange={setIsCollapsed}>
            <ProfileTagsSection
              tags={profile?.creatorType || []}
              emptyText="Tell us your Skills"
              title="Creator Type(s)"
            />
            <ProfileTagsSection
              tags={profile?.contentType || []}
              emptyText="Tell us your Niche"
              title="Content Type(s)"
            />
            <ProfileTagsSection
              tags={profile?.collabInterest || []}
              emptyText="Tell us what you are looking for..."
              title="Collaboration Type(s)"
            />
          </CollapsibleLayout>
        </div>
      </div>

      {isOwnProfile && isMobile && (
        <div className="px-20">
          <ProfileViewNotification />
        </div>
      )}

      <div className='block hidden--tablet px-20'>
        <DealSyncCard />
      </div>

      <HighlightsList />
      <ProjectListSection />

      {showAnalyticsEmptyState && (
        <ProfileOverviewAnalyticsEmptyState />
      )}
    </div>
  )
}
